(function() {
    'use strict';

    angular.module('app').controller('PuescManagementCtrl', [
        '$scope',
        '$http',
        '$translate',
        '$ngConfirm',
        '$timeout',
        '$interval',
        '$window',
        'toaster',
        function($scope, $http, $translate, $ngConfirm, $timeout, $interval, $window, toaster) {
            $scope.LIST_TAB = 'vehicles';
            $scope.HISTORY_TAB = 'history';

            $scope.STEP_SEARCH = 1;
            $scope.STEP_LIST = 2;
            $scope.STEP_ACTION = 3;

            $scope.changeTab = function(v) {
                $scope.tab = v;
            };

            $scope.isTab = function(tab) {
                return $scope.tab === tab;
            };

            $scope.changeStep = function(v) {
                $scope.step = v;
            };

            $scope.isStep = function(step) {
                return $scope.step >= step;
            };

            $scope.isStepDisabled = function(step) {
                return $scope.step !== step;
            };

            $scope.tab = $scope.LIST_TAB;
            $scope.step = $scope.STEP_SEARCH;

            $scope.puesc = {
                list: [],
                selected: null,
            };

            $scope.filters = {
                objects: {
                    search: null,
                },
            };

            $scope.openInformationModal = openInformationModal;
            $scope.searchPuescObjects = searchPuescObjects;
            $scope.showPuescLogs = showPuescLogs;
            $scope.resetPuescObjects = resetPuescObjects;
            $scope.choosePuescObject = choosePuescObject;

            $scope.deletePuescObject = deletePuescObject;
            $scope.fixObjectHistory = fixObjectHistory;
            $scope.transferObjects = transferObjects;

            $scope.togglePuescObjectField = togglePuescObjectField;

            $scope.hasPuescObjectStatus = function(object, statuses) {
                return statuses.indexOf(object.status) >= 0;
            };

            function choosePuescObject(row) {
                $scope.puesc.selected = row;
                $scope.changeStep($scope.STEP_ACTION);
            }

            function resetPuescObjects() {
                $scope.changeStep($scope.STEP_SEARCH);
                $scope.filters.objects.search = null;

                return searchPuescObjects();
            }

            function searchPuescObjects() {
                var search = $scope.filters.objects.search;

                return $http
                    .get('/rest-api/ms/puesc/api/management', {
                        params: {
                            search: search,
                        },
                    })
                    .then(function(response) {
                        return response.data || [];
                    })
                    .then(function(data) {
                        $scope.puesc.list = data;

                        return data;
                    })
                    .then(function(data) {
                        if (data.length) {
                            $scope.changeStep($scope.STEP_LIST);
                        }
                    });
            }

            function deleteInstructions(cb) {
                var $isolated = $scope.$new(true);
                $isolated.softly = true;

                $ngConfirm({
                    title: $translate.instant('puesc-management.modals.delete.title'),
                    contentUrl: 'tpl/pages/puesc-management/modals/delete.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'large',
                    icon: 'fas fa-info-circle',
                    scope: $isolated,
                    buttons: {
                        action: {
                            text: $translate.instant('general.confirm.ok'),
                            btnClass: 'btn-info',
                            action: function() {
                                return cb();
                            },
                        },
                    },
                });
            }

            function confirmSelectedOperation(cb) {
                $ngConfirm({
                    title: $translate.instant('puesc.confirm.title'),
                    content: $translate.instant('puesc.confirm.content'),
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-road',
                    buttons: {
                        no: {
                            text: $translate.instant('general.confirm.delete.no'),
                            btnClass: 'btn-dark',
                        },
                        yes: {
                            text: $translate.instant('general.confirm.delete.yes'),
                            btnClass: 'btn-danger',
                            action: function() {
                                return cb();
                            },
                        },
                    },
                });
            }

            function confirmOperationWithRanges(object, cb) {
                var $isolated = $scope.$new(true);

                $isolated.lock = false;
                $isolated.form = {
                    start: moment().set({ second: 0 }),
                    end: moment().set({ second: 59 }),
                };

                if (object) {
                    $isolated.object = object;
                    $isolated.form.id = object.object_id;
                }

                $isolated.action = function(payload) {
                    if (!payload.system || !payload.source) {
                        toaster.error(
                            $translate.instant('general.toastr.error.header'),
                            $translate.instant('puesc-management.toastr.error.system')
                        );

                        return false;
                    }

                    payload.start = moment(payload.start).format('YYYY-MM-DD HH:mm:ss');
                    payload.end = moment(payload.end).format('YYYY-MM-DD HH:mm:ss');

                    $isolated.lock = true;

                    return $http
                        .post('/rest-api/ms/puesc/api/management/completer', payload)
                        .then(
                            function(response) {
                                $isolated.lock = false;
                                $isolated.result = response.data;
                            },
                            function() {
                                $isolated.lock = false;
                            }
                        )
                        .catch(function() {
                            toaster.error(
                                $translate.instant('general.toastr.error.header'),
                                $translate.instant('puesc-management.toastr.error.timeout')
                            );

                            $isolated.lock = false;
                        });
                };

                $ngConfirm({
                    title: $translate.instant('puesc-management.fixer.title'),
                    contentUrl: 'tpl/pages/puesc-management/modals/fixer.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-road',
                    scope: $isolated,
                    buttons: {
                        no: {
                            text: $translate.instant('puesc-management.fixer.no'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            }

            function transferObjects() {
                var $isolated = $scope.$new(true);
                var step = 1;

                $isolated.lock = false;

                $isolated.objects = [];
                $isolated.selected = {};

                $isolated.sender = {};
                $isolated.receiver = {};

                $isolated.form = {
                    login: null,
                    client: null,
                };

                var $dialog = $ngConfirm({
                    title: $translate.instant('puesc-management.transfer.title'),
                    contentUrl: 'tpl/pages/puesc-management/modals/transfer.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-arrows-alt-h',
                    scope: $isolated,
                    buttons: {
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });

                $isolated.isStep = function(num) {
                    return step === num;
                };

                function __fit() {
                    $timeout(function() {
                        $window.dispatchEvent(new Event('resize'));
                    }, 1);
                }

                function __nextStep() {
                    step++;

                    __fit();
                }

                $isolated.load = function() {
                    $isolated.lock = true;

                    return $http
                        .get('/rest-api/ms/puesc/api/management/client-login', {
                            params: $isolated.form,
                        })
                        .then(function(response) {
                            $isolated.sender = response.data;

                            return $isolated.sender;
                        })
                        .then(function(data) {
                            return $http.get('/rest-api/ms/puesc/api/management/login-objects/' + data.login);
                        })
                        .then(function(response) {
                            $isolated.objects = response.data || [];

                            __nextStep();
                        })
                        .catch(function() {
                            toaster.error(
                                $translate.instant('general.toastr.error.header'),
                                $translate.instant('puesc-management.toastr.error.account')
                            );
                        })
                        .finally(function() {
                            $isolated.lock = false;
                        });
                };

                $isolated.list = function(obj) {
                    return Object.keys(obj).reduce(function(res, key) {
                        if (obj[key] === true) {
                            res.push(Number(key));
                        }

                        return res;
                    }, []);
                };

                $isolated.choose = function() {
                    $isolated.form = {
                        login: null,
                        client: null,
                    };

                    __nextStep();
                };

                $isolated.receiver = function() {
                    $isolated.lock = true;

                    return $http
                        .get('/rest-api/ms/puesc/api/management/client-login', {
                            params: $isolated.form,
                        })
                        .then(function(response) {
                            $isolated.receiver = response.data;

                            return $isolated.receiver;
                        })
                        .then(function() {
                            __nextStep();
                        })
                        .catch(function() {
                            toaster.error(
                                $translate.instant('general.toastr.error.header'),
                                $translate.instant('puesc-management.toastr.error.account')
                            );
                        })
                        .finally(function() {
                            $isolated.lock = false;
                        });
                };

                $isolated.finish = function() {
                    return $http
                        .post('/rest-api/ms/puesc/api/management/transfer', {
                            sender: $isolated.sender,
                            objects: $isolated.list($isolated.selected),
                            receiver: $isolated.receiver,
                        })
                        .then(function() {
                            toaster.success(
                                $translate.instant('general.toastr.success.header'),
                                $translate.instant('puesc-management.toastr.success.transfer')
                            );

                            $dialog.close();
                        })
                        .catch(function() {
                            toaster.error(
                                $translate.instant('general.toastr.error.header'),
                                $translate.instant('puesc-management.toastr.error.transfer')
                            );
                        });
                };
            }

            function fixObjectHistory(object) {
                return confirmOperationWithRanges(object, function() {});
            }

            function deletePuescObject(object) {
                return deleteInstructions(function() {
                    return confirmSelectedOperation(function() {
                        return $http.delete(`/rest-api/ms/puesc/api/management/${object.id}`).then(
                            function() {
                                searchPuescObjects();
                            },
                            function() {}
                        );
                    });
                });
            }

            function showPuescLogs() {
                var $isolated = $scope.$new(true);

                $isolated.logs = [];
                $isolated.search = function(key) {
                    return $http
                        .get('/rest-api/ms/puesc/api/management/logs', {
                            params: {
                                search: key,
                            },
                        })
                        .then(function(response) {
                            $isolated.logs = response.data || [];
                        });
                };

                $isolated.search('');

                $ngConfirm({
                    title: $translate.instant('puesc-management.modals.logs.title'),
                    contentUrl: 'tpl/pages/puesc-management/modals/logs.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-book',
                    scope: $isolated,
                    buttons: {
                        cancel: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            }

            function openInformationModal(object) {
                var $isolated = $scope.$new(true);
                $isolated.object = object;

                $ngConfirm({
                    title: $translate.instant('puesc.modals.information.title'),
                    contentUrl: 'tpl/pages/puesc/modals/information.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-info-circle',
                    scope: $isolated,
                    buttons: {
                        cancel: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            }

            function handleModificationError(error) {
                if (error.status !== 406) {
                    return;
                }

                toaster.error(
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('puesc.toastr.error.deactivating')
                );
            }

            function updatePuescObject(id, payload) {
                return confirmSelectedOperation(function() {
                    return $http.put(`/rest-api/ms/puesc/api/management/${id}`, payload).then(function() {
                        searchPuescObjects();
                    }, handleModificationError);
                });
            }

            function togglePuescObjectField(object, field) {
                var payload = {};
                payload[field] = !object[field];

                return updatePuescObject(object.id, payload);
            }

            function init() {
                resetPuescObjects();
            }

            init();
        },
    ]);
})();
